// extracted by mini-css-extract-plugin
export default {"container":"MenuSlot_container__xCTsr","darkBackground":"MenuSlot_darkBackground__iQN3m"};